const getSensors = () => {

  return new Promise((resolve, reject) => {

    window.apiRequest('get', '/sensors/all').then(r => {

      if(r.type === 'success') {
        resolve(r.data.items);
      } else {
        reject();
      }

    });

  });

};

export default getSensors;
